// Input.tsx
import React, { forwardRef } from 'react';
import { StyledInput } from './Input.styles';

// 继承原生 input 的所有属性，并提供自定义的默认值
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // 如果需要额外的自定义属性，可以在这里添加
  // 例如：label?: string;
}

// 使用 forwardRef 允许父组件通过 ref 获取真实的 DOM 节点 (常用于表单库如 react-hook-form)
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ placeholder, ...restProps }, ref) => {
    return (
      <div style={{ flex: 1 }}>
        <StyledInput
          ref={ref}
          type="text"
          placeholder={placeholder}
          spellCheck={false} // 关闭拼写检查，避免输入框下方出现红波浪线
          {...restProps}     // 透传其余所有属性 (value, onChange, disabled 等)
        />
      </div>

    );
  }
);

// 设置组件显示名称，方便在 React DevTools 中调试
Input.displayName = 'Input';